export default __webpack_public_path__ + "static/media/Gopal-Kumarappan.ee6cc629.png";